import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { StatusPopupService, PopupState } from 'src/app/services/api/status-popup.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-status-popup',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="overlay" *ngIf="state.visible">
            <div class="popup-card">

                <!-- Close icon -->
                <span *ngIf="state.type === 'confirmation'" class="close-icon" (click)="closeOnly()">✕</span>

                <!-- Header -->
                <div class="header">
                    <div class="icon" [ngClass]="state.type" [innerHTML]="icon"></div>
                    <h3>{{ state.title }}</h3>
                </div>

                <!-- Content -->
                <p class="content">
                    {{ state.content }}
                </p>

                <!-- Footer -->
                <div class="footer">
                    <button (click)="close()">{{ state.buttonText || 'Close' }}</button>
                </div>

            </div>
        </div>
    `,
    styles: [`
        .overlay {
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.45);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10000;
        }

        .popup-card {
            background: #fff;
            width: 520px;
            border-radius: 10px;
            padding: 20px 24px 16px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            position: relative;
        }

        .close-icon {
            position: absolute;
            top: 12px;
            right: 14px;
            cursor: pointer;
            font-size: 18px;
            color: #555;
        }

        .header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
        }

        .icon {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
        }

        .icon{font-size: 22px;margin-top: 2px;}
        .icon.success { color: #038454; }
        .icon.warning { color: #facc15; }
        .icon.error   { color: #ef4444; }
        .icon.confirmation { color: #facc15; }

        h3 {
            margin: 0px 0px 0px -10px;
            font-size: 18px;
            font-weight: 600;
            color: #111;
        }

        .content {
            font-size: 14px;
            color: #444;
            margin: 10px 0 24px;
            line-height: 1.5;
        }

        .footer {
            display: flex;
            justify-content: flex-end;
        }

        button {
            background: #4c1d95;
            color: #fff;
            border: none;
            padding: 8px 18px;
            border-radius: 8px;
            font-size: 14px;
            cursor: pointer;
        }

        button:hover {
            opacity: 0.9;
        }
    `]
})
export class StatusPopupComponent implements OnInit, OnDestroy {

    state!: PopupState;
    private sub!: Subscription;

    constructor(private popupService: StatusPopupService, private sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.sub = this.popupService.popup$.subscribe(s => this.state = s);
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    get icon(): SafeHtml {
        let svg = '';

        switch (this.state.type) {
            case 'success':
                svg = `<i class="bi bi-check-circle"></i>`;
                break;

            case 'warning':
                svg = `<i class="bi bi-exclamation-triangle"></i>`;
                break;

            case 'error':
                svg = `<i class="bi bi-exclamation-circle"></i>`;
                break;
            case 'confirmation':
                svg = `<i class="bi bi-check2-circle"></i>`;
                break;
        }

        return this.sanitizer.bypassSecurityTrustHtml(svg);
    }

    close() {
        this.popupService.close();
    }

    closeOnly() {
        this.popupService.closeOnly();
    }
}
